import { useTranslation } from "react-i18next";
import { Icon, Label, Popup } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { formatDate } from "utils/dateHelperFunctions";

import type { NoteProps } from "modules/Dayplanner/components/AppointmentCard/components/NotificationIcons";

export const CallCustomerNote = ({ note: callCustomerNote }: NoteProps) => {
  const { t } = useTranslation();

  return (
    <Popup
      wide
      basic
      content={
        <div className="AppointmentNotePopup">
          <div className="AppointmentNoteTitle">
            <Icon className="phone flip green" />
            <span>{t("v8_call_customer_note", "Call Customer Note")}</span>
          </div>
          <div className="AppointmentNoteDescription">
            {callCustomerNote.updated_by
              ? `${callCustomerNote.updated_by.first_name} ${callCustomerNote.updated_by.last_name} ${t("v8_updated_call_customer_note", "updated Call Customer Note")} `
              : `${callCustomerNote.created_by?.first_name} ${callCustomerNote.created_by?.last_name} ${t("v8_added_call_customer_note", "added Call Customer Note")} `}
            {`${formatDate(callCustomerNote.updated_on, DATE_FORMATS_FNS.dateMonthYearTime)}`}
          </div>

          <div className="AppointmentNoteContent">
            <Label className="CallCustomerPhoneNr">{callCustomerNote.phone_nr}</Label>
            <div>{callCustomerNote.note}</div>
          </div>
        </div>
      }
      trigger={
        <Label circular color="green">
          <Icon className="phone flip white icon-vertical-align" />
        </Label>
      }
    />
  );
};
